<div class="fab-container bottom-nav">
    <button
        mat-fab
        class="fab-toggler {{ fabTogglerState }}"
        [ngClass]="fabTogglerState === 'inactive' ? 'toggle-fade' : ''"
        (click)="onToggleFab()">
        <i
            class="material-icons"
            [@fabToggler]="{ value: fabTogglerState }"
            >add</i
        >
    </button>
    <div [@speedDialStagger]="buttons.length">
        <div
            class="icons-inner-main"
            *ngIf="fabTogglerState == 'active'">
            <a
                class="fab-secondary"
                mat-mini-fab
                [routerLink]="btn.url"
                [queryParams]="btn.queryParams"
                (click)="onToggleFab(btn.onClick)"
                *ngFor="let btn of buttons"
                matTooltip="{{ btn.title }}"
                matTooltipClass="mat-mini-fab-tooltip">
                <svg-icon src="assets/images/menu/{{ btn.icon }}"></svg-icon>
            </a>
        </div>
    </div>
</div>
